import { createAsyncThunk } from "@reduxjs/toolkit";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";

const DEV_BASE_URL = process.env.REACT_APP_BASE_URL_DOC_GPT;
const DEV_BASE_URL_AI_MBR = process.env.REACT_APP_BASE_URL_AI_MBR;
export class AiMbrAPI {

    uploadPdf = createAsyncThunk(
        "/mbr/upload",
        async ({ data = {} }, { rejectWithValue }) => {
            try {
                setBaseURL(api, DEV_BASE_URL_AI_MBR);
                const response = await api.post("/mbr/upload", data, {
                    headers: {
                        "Content-Type": `multipart/form-data; boundary=${data._boundary}`,
                    },
                });
                return response.data;
            } catch (error) {
                return rejectWithValue(error.message);
            }
        }
    )

    getPdfList = createAsyncThunk(
        "mbr/list",
        async () => {
            try {
                setBaseURL(api, DEV_BASE_URL_AI_MBR);
                const response = await api.post("/mbr/list", {});
                const filteredData = response.data.data
                // .map(obj => ({
                //     ...obj,
                //     file: obj.file.filter(fileObj => fileObj.embedded !== false)
                // }));
                return filteredData;
            } catch (error) {
                throw error;
            }
        }
    );
    
    generateAnswer = createAsyncThunk(
        "mbr/conversation",
        async (data, { rejectWithValue }) => {
            try {
                setBaseURL(api, DEV_BASE_URL_AI_MBR);
                const response = await api.post("/mbr/conversation", data);
                return response.data;
            } catch (error) {
                return rejectWithValue(error.response.data);
            }
        }
    );

    saveFeedback = createAsyncThunk(
        "/mbr/feedback",
        async (data, { rejectWithValue }) => {
            try {
                setBaseURL(api, DEV_BASE_URL_AI_MBR);
                const response = await api.post("/mbr/feedback", data);
                return response.data;
            } catch (error) {
                return rejectWithValue(error.message);
            }
        }
    )
}
